import React from 'react';
import { CompanyManagement } from '@/components/company';

export const CompaniesPage: React.FC = () => {
  return <CompanyManagement />;
};